var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBlogCityFeatured(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#19f59b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_Blog_Stadt_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.22,331c79.3,15.64,167.7,17.64,237.81-19.63,53-28.19,91.64-78,103.13-133,3.95-18.92,4.76-38.83-1.75-57.16C395.59,71,332.92,49.85,281.18,26.42,241.88,8.62,223.44-1.3,181.57,4.15c-38.53,5-37.45,5.3-68.51,27.12C99.29,40.94,88.13,55.46,73.3,65.54c0,0-83.53,40.93-70,149.17C11.11,277.22,40.41,319.64,74.22,331Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.39,395.63c-.46.12.47-.14,0,0-18,5.22-36.4,14.35-46.6,29.89a48.28,48.28,0,0,0-6.2,39.58c1.32,4.47,3.39,8.82,6.79,12,9.3,8.79,24.55,6.55,37.81,6,10.06-.44,15-.32,22.95-6,7.34-5.23,7.47-9.17,11.87-16.91,2-3.48,2.1-7.69,3.45-7.91,0,0,19.92-59.9-30.07-56.63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlogCityFeatured);
export default __webpack_public_path__ + "static/media/bg_blog_city_featured.39365b47343526b2ee420e011ea2de9b.svg";
export { ForwardRef as ReactComponent };